import { NgComponentOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthPage, DynamicComponent, ScriptPageKeys } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';
import { Variant3Component } from './variant3/variant3.component';
import { AuthBaseComponent } from './auth.base.component';

@Component({
  selector: 'b2c-auth',
  imports: [NgComponentOutlet],
  templateUrl: './auth.component.html',
})
export class AuthComponent extends AuthBaseComponent implements OnInit {
  public config: AuthPage = this.loyaltyChallengeConfig.pages
    .authPage as AuthPage;

  public components: DynamicComponent<AuthPage> = {
    [this.Variants.VARIANT_1]: {
      component: Variant1Component,
      inputs: { config: this.config },
    },
    [this.Variants.VARIANT_2]: {
      component: Variant2Component,
      inputs: { config: this.config },
    },
    [this.Variants.VARIANT_3]: {
      component: Variant3Component,
      inputs: { config: this.config },
    },
  };

  ngOnInit(): void {
    this.metaService.setMeta(this.config.meta);
    this.taggingService.loadScriptForPage(ScriptPageKeys.AUTH);
  }
}
